import { getKeys } from '@morph-mapper/utils';
import { makeRegistry } from './utils/types';
import type { PluginHooks } from './types';
import { anchorExtract } from './definitions/anchor-extract';
import { useTableLogic } from './definitions/declare-items';
import { useIterator } from './definitions/iterators';
import { sortSuggestions } from './definitions/sort-suggestions';
import { Selector } from './definitions/ai-selector';
import { Checking } from './definitions/ai-checking';
import { numberHandling } from './definitions/number-handling';
import { splitHandling } from './definitions/split-handling';
/**
 * Enum of available plugins.
 */
export enum Plugin {
  AnchorExtract = 'anchorExtract',
  DeclareItems = 'declareItems',
  Iterator = 'iterator',
  sortSuggestions = 'sortSuggestions',
  AiSelector = 'Selector',
  AiChecking = 'Checking',
  NumberHandling = 'numberHandling',
  SplitHandling = 'splitHandling'
}

/**
 * Registry of available plugins.
 */
export const registry = makeRegistry({
  [Plugin.AnchorExtract]: anchorExtract,
  [Plugin.DeclareItems]: useTableLogic,
  [Plugin.Iterator]: useIterator,
  [Plugin.sortSuggestions]: sortSuggestions,
  [Plugin.AiSelector]: Selector,
  [Plugin.AiChecking]: Checking,
  [Plugin.NumberHandling]: numberHandling,
  [Plugin.SplitHandling]: splitHandling,
} as const);

/**
 * List of available plugins.
 */
export const availablePlugins = getKeys(registry);

/**
 * Whether a plugin key from saved data is still registered. Templates can
 * list plugins that were removed after they were saved.
 */
export const isRegisteredPlugin = (key: unknown): key is Plugin =>
  availablePlugins.includes(key as Plugin);
